import React, { useContext } from 'react';
import Select from 'react-select';
import { withAsyncPaginate } from 'react-select-async-paginate';
import { Menu, MultiValueRemove, ValueContainer, NoOptionsMessage, Option, LoadingMessage, } from './SearchReplacmentsComponents';
import { st, classes } from './SearchEntity.st.css';
import { DEFAULT_ROWS_NUMBER } from './constants';
import { customStyles } from './CustomStyles';
import { TPAComponentsContext } from 'wix-ui-tpa';
import { DashboardMultiSelect } from './DashboardMultiSelect';
// @ts-ignore
const CustomAsyncPaginate = withAsyncPaginate(Select);
async function loadOptions(search, _loadedOptions, additional) {
    const { queryFunction, nextCursor } = additional;
    const response = await queryFunction(search, nextCursor);
    const optionsList = (response.items || []).map((item) => {
        item.value = item.id;
        item.label = item.role;
        return item;
    });
    return {
        options: optionsList,
        hasMore: response.nextCursor !== null,
        additional: { queryFunction, nextCursor: response.nextCursor },
    };
}
function SearchEntity(props) {
    const { mobile, rtl } = useContext(TPAComponentsContext);
    const { setSelectedRoles, queryFunction, value, placeholder, rows, allOptionsSelected, filterShowOnlyInSelectList, loadingMessage, noOptionsMessage, className, numberOfResultsMessage = '', pressDeleteToRemoveMessage = '', searchEntityRef, isDashboard, updatedItems, } = props;
    const customComponents = {
        DropdownIndicator: null,
        IndicatorSeparator: null,
        Menu: Menu(numberOfResultsMessage),
        MultiValueRemove: MultiValueRemove(pressDeleteToRemoveMessage),
        Option,
        ValueContainer,
        LoadingIndicator: null,
        LoadingMessage,
        NoOptionsMessage,
    };
    const values = value || [];
    const shownValues = values.filter((item) => !item.showOnlyInSelectList);
    const onSelect = (e) => {
        if (setSelectedRoles) {
            setSelectedRoles((e ?? []));
        }
    };
    const filterOptions = (candidate, _input) => {
        if (!filterShowOnlyInSelectList) {
            return true;
        }
        return !candidate.data.showOnlyInSelectList;
    };
    return isDashboard ? (React.createElement(DashboardMultiSelect, { placeholder: placeholder, loadOptions: loadOptions, queryFunction: queryFunction, isDashboard: isDashboard, onSelect: setSelectedRoles, value: value, shownValues: shownValues, filterShowOnlyInSelectList: filterShowOnlyInSelectList, updatedItems: updatedItems })) : (React.createElement(CustomAsyncPaginate, { selectRef: searchEntityRef, isMulti: true, cacheOptions: true, defaultOptions: false, styles: customStyles({
            ...props,
            rows: rows || DEFAULT_ROWS_NUMBER,
        }, rtl || false), value: shownValues, loadingMessage: () => loadingMessage || null, placeholder: placeholder, "aria-label": placeholder, isClearable: false, classNamePrefix: 'search-entity', noOptionsMessage: ({ inputValue }) => {
            if (`${inputValue}`.trim().length) {
                return `${noOptionsMessage}`;
            }
            return `${allOptionsSelected}`;
        }, className: st(classes.root, { mobile, rtl }, className), components: customComponents, onChange: onSelect, additional: {
            queryFunction,
            nextCursor: null,
        }, filterOption: filterOptions, loadOptions: loadOptions, debounceTimeout: 300, autoFocus: true }));
}
export default SearchEntity;
//# sourceMappingURL=SearchEntity.js.map